'use strict';

var _regeneratorRuntime = require("/Users/edtsech/code/projects/duonote/node_modules/@babel/runtime/regenerator");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator['throw'](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    default: mod
  };
};

Object.defineProperty(exports, '__esModule', {
  value: true
});

var adaptor_1 = __importDefault(require('../adaptor'));

var data_1 = require('../data');

var doc_1 = require('../doc');

var ref_1 = require('../ref');
/**
 * Adds a new document with a random id to a collection.
 *
 * ```ts
 * import { add, collection } from 'typesaurus'
 *
 * type User = { name: string }
 * const users = collection<User>('users')
 *
 * add(users, { name: 'Sasha' }).then(sasha => {
 *   console.log(sasha.ref.id)
 *   //=> '00sHm46UWKObv2W7XK9e'
 *   console.log(sasha.data)
 *   //=> { name: 'Sasha' }
 * })
 * ```
 *
 * @param collection - The collection to add to
 * @param data - The data to add to
 * @returns A promise to the document
 */


function add(collection, data) {
  return __awaiter(this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    var firebaseDoc;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return adaptor_1.default().collection(collection.path).add(data_1.unwrapData(data));

          case 2:
            firebaseDoc = _context.sent;
            return _context.abrupt("return", doc_1.doc(ref_1.ref(collection, firebaseDoc.id), data));

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
}

exports.default = add;